module.exports = __webpack_public_path__ + "img/9.db4fbfca.png";